











import {ChartDataTemplate, FCConfTpl, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {bus} from "@/main"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "AuditRoomStatus",
      title: "Audited room status",
      _description: "Audit room status",
      params: {
        auditCategory: {...WParamTpl.auditCategory(), _order: 1},
      },
      fusionChartParams: {
        numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        // paletteColors: "#6baa01, #DC143C, #FFBF00",
        showZeroPies: "1",
        showPercentValues: "1",
        showPercentInTooltip: "1",
        animation: "0",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Category: " + (config.params.auditCategory.value.title || "<All>")
    }
  }

  export default defineComponent({
    props: {
      config: {type: Object, required: true},
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
      const toDate = getTodayYYYYMMDD()
      let noAccessReasonIds: string[]

      async function dataFetcher(params: any): Promise<{ data: any[] }> {
        // @fromDate smalldatetime, @toDate smalldatetime,
        // @auditTemplateID bigint = 0, @riskID AS bigint = 0, @functionalAreaID bigint = 0, @auditPurposeID bigint = 0,
        // @teamID bigint = 0, @responsibleGroupID bigint = 0, @departmentID bigint = 0, @elementTypeID bigint = 0
        const categoryID = params.auditCategory.value.value || 0
        const data = await executeQuery("micad4-audit", "mostCommonNoAccessReasons",
          {locale: "en-GB", fromDate, toDate, categoryID}, // todo pass all parameters
          filter) // todo pass all parameters
        noAccessReasonIds = data.map(item => item.labelId)
        return {data}
      }

      function dataplotClickCallback(label: string, val: any, data: any) {
        if (val === undefined) {
          return
        }
        const noAccessReasonId = noAccessReasonIds[data.index]
        bus.$emit('chartPopup', {
          title: "Most common no access reasons: " + label + " (" + val + ")",
          component: () => import('@/components/widgets/audit/AuditMostCommonNoAccessReasonsDrillDown.vue'),
          componentArgs: {
            fromDate: fromDate,
            toDate: toDate,
            reasonId: noAccessReasonId,
            categoryId: props.config.params.auditCategory.value.value,
          },
        })
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })

  function filter(data: { name: string, count: number, noAccessReasonID: number }[]): any[] {
    return data.map(item => {
      return {
        label: item.name,
        value: item.count,
        labelId: item.noAccessReasonID,
      }
    })
  }
